module.exports = __webpack_public_path__ + "img/extended.cf4a24c7.png";